import { canUseDom } from '@argos/utils'

export const ensureStructure = (window) => {
  window.digitalData = window.digitalData || {}
  window.digitalData.page = window.digitalData.page || {}
  window.digitalData.page.attributes = window.digitalData.page.attributes || {}
  window.digitalData.page.attributes.livechat = window.digitalData.page.attributes.livechat || {}
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {}
  window.digitalData.page.lightBox.type = window.digitalData.page.lightBox.type || []
  window.digitalData.page.lightBox.page = window.digitalData.page.lightBox.page || []
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
}

export const initTracking = () => {
  ensureStructure(window)
}

export const doTrackEvent = (event, name, attributes) => {
  if (canUseDom()) {
    window.digitalData.event.push(event)
    window.digitalData.page.attributes.livechat = attributes
    window.digitalData.track(name)
  }
}

export const doTrackLightbox = (page, type = 'livechat') => {
  if (canUseDom()) {
    window.digitalData.page.lightBox.page = page
    window.digitalData.page.lightBox.type = type
    window.digitalData.track('livechatLbPage')
  }
}
